import { Link } from "react-router-dom";
const HomeAyurveda = () => {
  return <section className="w-full bg-gradient-to-b from-white via-[#f8f5f1] to-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4">
                {
    /* Mobile Layout - sm and below */
  }
                <div className="lg:hidden flex flex-col gap-8">
                    {
    /* Label */
  }
                    <p className="text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                        Ayurveda
                    </p>
                    <h2 className="font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl">
                        Die traditionelle Heilkunde, die als Mutter der Medizin gilt
                    </h2>

                    {
    /* Image */
  }
                    <div className="relative h-[280px] overflow-hidden sm:h-[380px]">
                        <img
    src="/images/Hiru/kapha-pitta-vata.webp"
    alt="Ayurveda-Behandlungsbild"className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                    </div>

                    {
    /* Content */
  }
                    <div>


                        <p className="mt-6 text-base font-semibold tracking-[0.2em] text-[#1f4d3c] sm:text-lg">
                            Weisheit des Lebens
                        </p>

                        <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-gray-700 sm:text-base">
                            <p>
                                Ayurveda ist eine alte indische Heilkunde, deren Wurzeln in den heiligen Texten aus über 2.500 Jahren liegen und zu den ältesten traditionellen Heilmethoden der Welt gehört. Ihre Weisheit hat die traditionelle chinesische Medizin, die westliche Kräutermedizin und sogar die Grundlagen der modernen Medizin maßgeblich beeinflusst.
                            </p>
                            <p>
                                Der Begriff stammt aus den Sanskritwörtern „Ayus“ (Leben) und „Veda“ (Wissen, Erkenntnis) und bedeutet „Wissenschaft des Lebens“. Ayurveda geht über einzelne Behandlungsmethoden hinaus und hilft dabei, die natürliche Lebensenergie wieder zu wecken und einen harmonischen, erfüllten Lebensweg zu finden.
                            </p>
                        </div>

                        <div className="mt-8">
                            <Link
    to="/ayurveda/panchakarma"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                Mehr erfahren
                            </Link>
                        </div>
                    </div>
                </div>

                {
    /* Desktop Layout - lg and above */
  }
                <div className="hidden lg:flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-16">
                    <div className="lg:w-7/12">
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                            Ayurveda
                        </p>

                        <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Die traditionelle Heilkunde, die als Mutter der Medizin gilt
                        </h2>

                        <p className="mt-8 text-lg font-semibold tracking-[0.2em] text-[#1f4d3c]">
                            Weisheit des Lebens
                        </p>

                        <div className="mt-6 space-y-5 text-[17px] leading-relaxed text-gray-700 lg:text-lg">
                            <p>
                                Ayurveda ist eine alte indische Heilkunde, deren Wurzeln in den heiligen Texten aus über 2.500 Jahren liegen und zu den ältesten traditionellen Heilmethoden der Welt gehört. Ihre Weisheit hat die traditionelle chinesische Medizin, die westliche Kräutermedizin und sogar die Grundlagen der modernen Medizin maßgeblich beeinflusst.
                            </p>
                            <p>
                                Der Begriff stammt aus den Sanskritwörtern „Ayus“ (Leben) und „Veda“ (Wissen, Erkenntnis) und bedeutet „Wissenschaft des Lebens“. Ayurveda geht über einzelne Behandlungsmethoden hinaus und hilft dabei, die natürliche Lebensenergie wieder zu wecken und einen harmonischen, erfüllten Lebensweg zu finden.
                            </p>
                        </div>

                        <div className="mt-10">
                            <Link
    to="/ayurveda/panchakarma"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-7 py-3 text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                Mehr über Ayurveda erfahren
                            </Link>
                        </div>
                    </div>

                    <div className="lg:w-5/12">
                        <div className="relative h-[320px] overflow-hidden sm:h-[420px] lg:h-[640px] xl:h-[700px]">
                            <img
    src="/images/Hiru/kapha-pitta-vata.webp"
    alt="Ayurveda-Behandlungsbild"className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default HomeAyurveda;
